import React from "react";

const ApiDocsRedirect = () => {
  return (
    <iframe
      src="fiep_api_documentation.html"
      title="Api Documentation"
      style={{
        width: "100%",
        height: "100vh",
        border: "0",
      }}
    />
  );
};
export default ApiDocsRedirect;
